<script lang="ts">
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { real_id } from 'src/helpers/interface_helpers';
	import LabelList from '@Shelly/shelly-design-system/LablelList/LabelList.svelte';
	import { LabelListV2 } from '@Shelly/shelly-design-system/index';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { mapIconSolidWeightToLight, mapLegacyColorToToken } from 'src/helpers/new-layout-helpers';
	import { getRoomLabelList } from 'src/helpers/room_label_list_helpers';
	import { consumption_device } from 'src/stores/features/consumption';
	import type { Room } from 'src/types/Room';

	export let item: Room, size;

	$: mainSensorStatusStore = item?.main_sensor ? getDeviceStatus(item.main_sensor) : undefined;
	$: mainSensorStatus = mainSensorStatusStore ? $mainSensorStatusStore : undefined;
	$: statusMap =
		item?.main_sensor && mainSensorStatus
			? { [real_id(item.main_sensor)]: mainSensorStatus }
			: {};
	$: labelList = getRoomLabelList(item, statusMap, $consumption_device);
</script>

{#if !$showNewLayout}
	<LabelList {labelList} {size} bgOpacity on:label-click />
{:else}
	<LabelListV2
		a11yProps={{ isInteractive: true }}
		labelList={labelList.map((el) => ({
			...el,
			icon: mapIconSolidWeightToLight(el?.icon),
			backgroundColor: mapLegacyColorToToken(el?.['type']),
		})) || []}
		{size}
		on:label-click
	/>
{/if}
